import { createFileRoute } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { Button } from "@/components/Button";
import { Footer } from "@/components/Footer/Footer";
import { HotelSearchForm } from "@/features/hotels/components/HotelSearchForm/HotelSearchForm";
import { useHotelSearchForm } from "@/features/hotels/hooks/useHotelSearchForm";
import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";
import { SearchCategorySwitcher } from "@/features/search/components/SearchCategorySwitcher";
import { applicationSettingsQueryOptions } from "@/hooks/useApplicationSettings";
import { BannersPlacementSlug } from "@/types/enums";

export const Route = createFileRoute("/_authenticated/hotels/search")({
  loader: async ({ context }) => {
    // default search settings are needed before rendering the form
    await context.queryClient.prefetchQuery(applicationSettingsQueryOptions());
  },
  component: RouteComponent,
});

function RouteComponent() {
  const intl = useIntl();

  const navigate = Route.useNavigate();

  const { handleSubmit: handleHotelSearchFormSubmit } = useHotelSearchForm();

  const handleHotelSearchSubmit = (values: HotelSearchFormValues) => {
    handleHotelSearchFormSubmit(values);
    navigate({ to: "/hotels/list" });
  };

  return (
    <main className="main">
      <div className="w-full space-y-3 p-main">
        <SearchCategorySwitcher current="hotels" />

        <div className="rounded-4xl bg-surface-base-light p-4 shadow-md">
          <HotelSearchForm
            submitButton={
              <div className="mt-2">
                <Button fullWidth variant="contained" type="submit">
                  {intl.formatMessage({
                    defaultMessage: "Search hotel",
                    description:
                      "Submit/search button label for the hotel search form",
                  })}
                </Button>
              </div>
            }
            analyticsSource="main"
            onSubmit={handleHotelSearchSubmit}
          />
        </div>

        <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_1} />
        <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_2} />
        <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_3} />
      </div>

      <Footer />
    </main>
  );
}
